export default __webpack_public_path__ + "static/media/search_not_found.3d8f814d.svg";